interface DiscountBadgeProps {
  listPrice?: number;
  price?: number;
  variant?: "default" | "dark";
}

const DiscountBadge = (
  { listPrice, price, variant = "default" }: DiscountBadgeProps,
) => {
  if (!listPrice || !price || listPrice === price) {
    return null;
  }

  const discountPercentage = 100 - Math.floor((price / listPrice) * 100);

  if (discountPercentage <= 0) {
    return null;
  }

  const percentage = Math.floor(discountPercentage);

  if (variant === "dark") {
    return (
      <div className="absolute left-2 top-2 p-2 rounded-0.5 bg-[#59574C] text-white font-bold text-xs z-20">
        {percentage}% OFF
      </div>
    );
  }

  // Tamanho fixo (sem breakpoint) copiado 1:1 do desktop pro mobile — numa
  // vitrine mobile (cards de ~180px de largura, grid-cols-2) essa caixa de
  // 60x22.5px com fonte de 17.66px fica desproporcional (quase 1/3 da
  // largura do card, bem maior que qualquer outro texto do card, que usa
  // text-[10px]/text-xs) — o "muito grosseira no mobile" reportado pelo
  // time. Reduzido só abaixo do breakpoint `lg`; acima de `lg` (onde o card
  // é bem mais largo) o tamanho/posição continuam idênticos aos de sempre.
  //
  // `bg-transparent` -> `bg-white`: o badge fica posicionado sobre a foto do
  // produto (ver `left-2 top-1`/`lg:left-10 lg:top-5` em ProductCard.tsx e
  // ProductItem.tsx); sem fundo sólido, quando o recorte da foto (`object-
  // cover`) deixa cabelo/rosto da modelo bem naquele canto, a borda/texto
  // preto do badge se mistura com a imagem em vez de "flutuar" como chip.
  return (
    <div className="flex font-['Bebas_Neue'] items-center justify-center bg-white font-normal leading-loose text-center text-[12px] lg:text-[17.6567px] uppercase text-black border border-black rounded-none p-0 pl-[3px] lg:pl-[5px] w-10 h-4 lg:w-15 lg:h-[22.5px]">
      {`${percentage}%`}
    </div>
  );
};

export default DiscountBadge;
